/* eslint-disable max-lines-per-function */
/* eslint-disable no-empty-function */
import { getImageIdentifier } from "@bluframe/mightychroma-mightytool-ui";
import { useCallback, useMemo, useState } from "react";
const DEFAULT_IMAGES = [];
export const initialContext = {
    addImage: () => { },
    editImage: () => { },
    images: DEFAULT_IMAGES,
    removeImage: () => { },
    resetImages: () => { },
    setImages: () => { }
};
const usePreviewsNewsCriticsContext = () => {
    const [images, setImages] = useState(DEFAULT_IMAGES);
    /**
     * addImage
     *
     * @description Add an image to the list of images
     * @param {Omit<ImageSelectorImage, "id">} image - The image to add
     * @returns {void}
     *
     */
    const addImage = useCallback((image) => {
        setImages((prevImages) => [...prevImages, image]);
    }, []);
    /**
     * editImage
     *
     * @description Edit an image in the list of images
     * @param {Omit<ImageSelectorImage, "serviceName">} image - The image to edit
     * @returns {void}
     *
     */
    const editImage = useCallback((image) => {
        setImages((prevImages) => {
            const imageIdentifier = getImageIdentifier(image);
            return prevImages.map((item) => {
                const itemIdentifier = getImageIdentifier(item);
                return itemIdentifier === imageIdentifier
                    ? { ...item, originalUrl: image.originalUrl }
                    : item;
            });
        });
    }, []);
    /**
     * removeImage
     *
     * @description Remove an image from the list of images
     * @param {ImageSelectorImage} image - The service name of the image to remove
     * @returns {void}
     *
     */
    const removeImage = useCallback((image) => {
        setImages((prevImages) => {
            const imageIdentifier = getImageIdentifier(image);
            return prevImages.filter((item) => {
                const itemIdentifier = getImageIdentifier(item);
                return itemIdentifier !== imageIdentifier;
            });
        });
    }, []);
    /**
     * resetImages
     *
     * @description Reset the list of images to the default
     * @returns {void}
     *
     */
    const resetImages = useCallback(() => {
        setImages(DEFAULT_IMAGES);
    }, []);
    /**
     * onSetImages
     *
     * @description Set the list of images
     * @returns {void}
     *
     */
    const onSetImages = useCallback((newImages) => {
        setImages(newImages);
    }, []);
    /**
     * useMemo
     *
     * @description Memoize context values
     * @returns {PreviewsNewsCriticsContext} - Memoized context values
     *
     */
    return useMemo(() => ({
        addImage,
        editImage,
        images,
        removeImage,
        resetImages,
        setImages: onSetImages
    }), [addImage, editImage, images, onSetImages, removeImage, resetImages]);
};
export default usePreviewsNewsCriticsContext;
